// src/i18n/locales/ar/homePage.ts
export const arHomePageTranslations = {
	homepage: {
		features: 'المميزات',
		pricing: 'الأسعار',
		templates: 'القوالب',
		readyToStart: 'هل أنت مستعد لتحويل قائمة مطعمك؟',
		startDescription: 'انضم إلى آلاف المطاعم التي تعزز حضورها الرقمي مع منصتنا القابلة للتخصيص لقوائم الطعام.',
		stats: {
			title: 'موثوق به من قبل مطاعم حول العالم',
			subtitle: 'انضم إلى آلاف المطاعم التي حولت حضورها الرقمي بالفعل',
			restaurants: 'مطاعم سعيدة',
			menusViewed: 'قوائم يتم تصفحها شهريًا',
			salesIncrease: 'متوسط زيادة المبيعات',
			countries: 'دول مخدومة'
		},
		cta: {
			title: 'هل أنت مستعد لتحويل مطعمك؟',
			subtitle: 'انضم إلى آلاف المطاعم التي زادت مبيعاتها بقوائم رقمية جميلة.',
			rating: 'تقييم العملاء',
			trustedBy: 'موثوق به من قبل',
			restaurants: 'مطاعم',
			watchDemo: 'شاهد العرض التوضيحي',
			features: {
				setup: 'إعداد في 5 دقائق',
				support: 'دعم 24/7',
				guarantee: 'ضمان 30 يومًا'
			}
		}
	},
	hero: {
		titleHighlight: 'قوائم رقمية',
		titleRest: 'تسعد عملاءك',
		subtitle: 'أنشئ قوائم طعام مذهلة وقابلة للتخصيص وسهلة التحديث ومتاحة من أي جهاز.',
		browseTemplates: 'تصفح القوالب',
		trustBadge: 'موثوق به من قبل أكثر من 10,000 مطعم',
		restaurants: 'مطاعم تثق بنا',
		watchDemo: 'شاهد العرض التوضيحي',
		sales: 'نمو المبيعات',
		rating: 'التقييم'
	},
	features: {
		sectionTitle: 'كل ما تحتاجه للنجاح',
		sectionSubtitle: 'ميزات قوية مصممة خصيصًا للمطاعم لإنشاء قوائم رقمية مذهلة تزيد المبيعات.',
		badge: 'لماذا نحن؟',
		bottomCTA: 'انضم إلى أكثر من 10,000 مطعم ينمون بالفعل مع Dine.ai',
		customization: {
			title: 'تخصيص سهل',
			description: 'خصص قائمتك بألوان علامتك التجارية وخطوطك وتصميمك لتناسب هوية مطعمك تمامًا.',
		},
		responsive: {
			title: 'متجاوبة بالكامل',
			description: 'تبدو قائمتك مثالية على أي جهاز - من الهواتف الذكية والأجهزة اللوحية إلى أجهزة الكمبيوتر المكتبية.',
		},
		multilingual: {
			title: 'دعم متعدد اللغات',
			description: 'اخدم العملاء الدوليين من خلال تقديم قائمتك بعدة لغات مع دعم الاتجاه من اليمين إلى اليسار.',
		},
		analytics: {
			title: 'تحليلات متقدمة',
			description: 'احصل على رؤى حول أكثر العناصر مشاهدة وشعبية لتحسين عروضك وزيادة المبيعات.',
		},
		security: {
			title: 'آمن وموثوق',
			description: 'بياناتك محمية بأمان على مستوى المؤسسات، ونسخ احتياطية منتظمة، وتوفر بنسبة 99.9٪.',
		},
		performance: {
			title: 'سريع البرق',
			description: 'محسن للسرعة مع أوقات تحميل فورية تبقي عملاءك متفاعلين.',
		},
	},
	testimonials: {
		sectionTitle: 'ماذا يقول عملاؤنا',
		sectionSubtitle: 'لا تأخذ كلمتنا فقط - استمع إلى أصحاب المطاعم الذين حولوا أعمالهم مع Dine.ai.',
		badge: 'قصص العملاء',
		person1: {
			name: 'سارة جونسون',
			role: 'مالكة، ذا روستيك تيبل',
			content: 'حولت Dine.ai قوائمنا الورقية القديمة إلى تجربة رقمية جميلة. عملاؤنا يحبونها، وقد شهدنا زيادة بنسبة 20٪ في متوسط قيمة الطلب!',
		},
		person2: {
			name: 'مايكل تشين',
			role: 'مدير، فيوجن بيسترو',
			content: 'القدرة على تحديث عناصر وأسعار القائمة بسرعة كانت نقطة تحول. كما نحب التحليلات التي تساعدنا على فهم أطباقنا الأكثر شعبية.',
		},
		person3: {
			name: 'لوسيا غارسيا',
			role: 'شيف، لا ماريبوسا',
			content: 'بصفتي شخصًا يغير القائمة موسميًا، تجعل Dine.ai من السهل جدًا عرض أطباقنا الجديدة مع صور ووصف جميل.',
		},
	},
	benefits: {
		sectionTitle: 'حوّل تجربة مطعمك',
		sectionSubtitle: 'اكتشف كيف يمكن للقوائم الرقمية أن تُحدث ثورة في عمليات مطعمك وتعزز رضا العملاء.',
		business: {
			title: 'عزز أعمالك',
			description: 'زد الإيرادات من خلال فرص البيع الإضافي، وقلل تكاليف الطباعة، وحسن الكفاءة التشغيلية من خلال تحديثات القائمة الفورية.',
		},
		customer: {
			title: 'تجربة عملاء محسّنة',
			description: 'قدم للعملاء قوائم تفاعلية وجذابة بصرياً تتضمن أوصافاً تفصيلية ومعلومات الحساسية وصور عالية الجودة.',
		},
		efficiency: {
			title: 'وفر الوقت والموارد',
			description: 'تخلص من الحاجة لإعادة طباعة القوائم. حدث الأسعار والأوصاف والتوفر فورياً في جميع المواقع.',
		},
		environment: {
			title: 'حل صديق للبيئة',
			description: 'قلل هدر الورق وساهم في الاستدامة البيئية مع توفير تجربة طعام عصرية.',
		},
		accessibility: {
			title: 'إمكانية وصول شاملة',
			description: 'تأكد من إمكانية وصول جميع العملاء لقائمتك مع ميزات مثل اللغات المتعددة وخيارات النص الكبير والتوافق الصوتي.',
		},
		global: {
			title: 'وصول للجمهور العالمي',
			description: 'اجذب الزوار الدوليين بقوائم متعددة اللغات وخيارات عرض مناسبة ثقافياً.',
		},
		whyChoose: {
			title: 'لماذا تختار Dine.ai؟',
			description: 'يجمع Dine.ai بين التكنولوجيا المتطورة والتصميم سهل الاستخدام لتقديم حل قائمة رقمية شامل ينمو مع عملك.',
		},
		features: {
			easySetup: 'إعداد سريع',
			easySetupDesc: 'اجعل قائمتك الرقمية مباشرة في دقائق مع عملية الإعداد البديهية.',
			noMaintenance: 'صيانة صفر',
			noMaintenanceDesc: 'نحن نتولى جميع التحديثات التقنية والصيانة، حتى تتمكن من التركيز على عملك.',
			instantUpdates: 'تحديثات فورية',
			instantUpdatesDesc: 'تظهر التغييرات فورياً عبر جميع الأجهزة والمواقع.',
			support: 'دعم 24/7',
			supportDesc: 'فريق الدعم المخصص لدينا موجود دائماً لمساعدتك على النجاح.',
		},
	},
	footer: {
		description: 'تساعد Dine.ai المطاعم على إنشاء قوائم طعام رقمية جميلة وقابلة للتخصيص تسعد العملاء وتزيد المبيعات.',
		product: 'المنتج',
		features: 'المميزات',
		pricing: 'الأسعار',
		templates: 'القوالب',
		customization: 'التخصيص',
		company: 'الشركة',
		about: 'من نحن',
		blog: 'المدونة',
		careers: 'الوظائف',
		contact: 'اتصل بنا',
		support: 'الدعم',
		help: 'مركز المساعدة',
		docs: 'التوثيق',
		status: 'حالة النظام',
		privacy: 'سياسة الخصوصية',
		rights: 'جميع الحقوق محفوظة.',
	},
}